import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';
import CustomButton from './CustomButton';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function Identity() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">
        {/*
        <Box my={8}>
          <div class="text-danger line150 text-left border-danger">
            ■見学受け入れ休止のお知らせ<br />
            ※ 新型コロナウイルスの感染拡大を受け、当面の間、社内見学の受け入れを休止させていただきます。再開の時期につきましては、今後の感染状況などにより判断し、改めてお知らせいたします。
          </div>
        </Box>
        */}
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            見学申し込み
          </Typography>
          <dl>
            <dt>申し込み方法</dt>
            <dd>
              <span class="underline">先にお電話で見学希望日をご確認の上</span>、下記「見学申し込み」より、必要事項をご記入して送信してください。見学希望日の１ケ月前までにお申し込みください。
            </dd>
            <dt>見学可能日時</dt>
            <dd>
              平日　午前10時～正午、午後１時30分～午後３時30分<br/>
            </dd>
            <dt>見学人数</dt>
            <dd>
              30人以内（引率者含む）※要相談
            </dd>
          </dl>

          <Box my={8}>
            <Typography className="font-weight-bold my-3" variant="h5" component="h2">
              見学の内容
            </Typography>
            <dl>
              <dt>（１）正面玄関前（悪天候時は（４）の印刷工場内）で記念写真撮影</dt>
              <dd>本ホームページと翌日の本紙地域面に掲載いたします。</dd>
              <dt>（２）５階会議室でＤＶＤ上映</dt>
              <dd>新聞ができるまでの流れを説明した弊社の紹介映像を鑑賞します。</dd>
              <dt>（３）４階編集局の見学</dt>
              <dd>新聞製作の心臓部である職場を見学します。</dd>
              <dt>（４）印刷工場の見学</dt>
              <dd>本社に隣接する工場を見学します。（ただし輪転機は稼働しておりません）</dd>
            </dl>
            <div class="fs90 text-danger line150 text-left m-3">
              ※所要時間は通常１時間30分程度です。（約１時間にすることもできます）<br/>
              {/*
              ※学校で複数クラス申し込みの場合は、半数ずつで（３）と（４）を交互に見学します。<br/>
              */}
            </div>
            <div class="fs90 text-danger line150 text-left m-3">
              ※土・日曜や祝祭日、年末年始などは休ませていただきます。<br/>
              ※他の予定と重なった場合、日時を調整させていただくことがありますので、あらかじめご了承ください。<br/>
            </div>
          </Box>

          <Box my={4} textAlign="center">

            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={6}>
                {/*
                <CustomButton href="http://feature.daily-tohoku.co.jp/web2/company/form/kengaku/index.php" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  見学申し込み
                </CustomButton>
                */}
                <CustomButton href="https://form.daily-tohoku.org/kengaku" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  見学申し込み
                </CustomButton>
              </Grid>
            </Grid>
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="/tour/album/2026" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  見学アルバム2026
                </CustomButton>
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomButton href="/tour/album/2025" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  見学アルバム2025
                </CustomButton>
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomButton href="/tour/album/2024" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  見学アルバム2024
                </CustomButton>
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomButton href="/tour/album/2023" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  見学アルバム2023
                </CustomButton>
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomButton href="/tour/album/2022" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  見学アルバム2022
                </CustomButton>
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomButton href="/tour/album/2021" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  見学アルバム2021
                </CustomButton>
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomButton href="/tour/album/2020" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  見学アルバム2020
                </CustomButton>
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomButton href="/tour/album/2019" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  見学アルバム2019
                </CustomButton>
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomButton href="/tour/album/2018" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  見学アルバム2018
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            お問い合わせ
          </Typography>
          <dl>
            <dt>デーリー東北新聞社　読者センター</dt>
            <dd>
              <PhoneEnabledIcon /> 0178-80-7105<br/>
              ※受付時間　平日の午前９時30分～午後５時
            </dd>
          </dl>
        </Box>

      </div>
    </div>
  );
}

export default Identity;
